import { render } from "./CountryPortfolio.vue?vue&type=template&id=53ab0290&scoped=true"
import script from "./CountryPortfolio.vue?vue&type=script&lang=js"
export * from "./CountryPortfolio.vue?vue&type=script&lang=js"

import "./CountryPortfolio.vue?vue&type=style&index=0&id=53ab0290&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ab0290"]])

export default __exports__